import { useState } from 'react';
import { Button } from '@/components/common/Button';
import { Modal } from '@/components/common/Modal';
import { TextField } from '@/components/forms/Field';

/**
 * Granting or refusing relief.
 *
 * <p>The two outcomes are given equal weight and separate buttons rather than a
 * toggle with a confirm: approving money off a family's bill and refusing it are
 * different decisions, and neither should be reachable by mis-clicking the
 * other. Refusing requires a reason, because a rejection nobody can explain is
 * one that will simply be proposed again next week.
 */
export function ApprovalDialog({
  open,
  onClose,
  onDecide,
  title,
  summary,
  pending,
}: {
  open: boolean;
  onClose: () => void;
  onDecide: (approved: boolean, reason: string) => void;
  title: string;
  summary: string;
  pending: boolean;
}) {
  const [reason, setReason] = useState('');

  return (
    <Modal
      open={open}
      title={title}
      description={summary}
      onClose={() => { setReason(''); onClose(); }}
      footer={
        <>
          <Button variant="secondary" onClick={() => { setReason(''); onClose(); }}>
            Not now
          </Button>
          <Button variant="danger" loading={pending} disabled={reason.trim() === ''}
                  onClick={() => onDecide(false, reason)}>
            Refuse
          </Button>
          <Button loading={pending} onClick={() => onDecide(true, reason)}>
            Approve
          </Button>
        </>
      }
    >
      <TextField
        label="Note"
        placeholder="Confirmed by the head"
        hint="Required to refuse; optional to approve. Either way it is recorded against the decision."
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
    </Modal>
  );
}
